import { isAdminApp } from '~/public/lib/PageHelpers';
import { useBusinessInfo } from '~/lib/Queries';
import { useContext } from 'react';
import { FormContext } from '~/components/forms/FormContext';
import { ConfirmationContext } from '~/lib/ConfirmationContext';
import { useBusinessContext } from '~/lib/BusinessContext';

const useCurrentBusiness = () => {
    // First check if BusinessContext is set (for public pages like invoice view)
    const businessContext = useBusinessContext();
    if (businessContext?.business) {
        return businessContext.business;
    }

    if (isAdminApp()) {
        const { data } = useBusinessInfo();
        return data?.business;
    } else {
        // Try the form
        const formContext = useContext(FormContext);
        const confirmationContext = useContext(ConfirmationContext);

        if (formContext?.form) {
            return formContext?.form?.business;
        } else {
            // Try confirmation context
            return confirmationContext?.submission?.form?.business;
        }
    }
};

export default useCurrentBusiness;
